<div *ngIf="value" class="empty-state">
    {{value}}
</div>